import _ from 'lodash'
import * as query from '@/queries/product'
import utils from '@/store/utils'

export const defaultState = function () {
  return {
    mode: 0,
    returnList: false, // 一覧から呼び出された詳細画面であるか
    tableSetList: [{}],
    tdLists: [],
    totalCount: 0,
    listIndex: -1,
    currentPage: 0,
    size: 10,
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'product_list',
    searchConditions: [],
    customizeMaster: [],
    colorMaster: [],
    colorGroupMaster: [],
    sizeMaster: [],
    sizeGroupMaster: [],
    brandMaster: [],
    genderMaster: [],
    htmlPreviewDialogVisible: false,
    htmlPreviewDialogContent: '',
    // 表示項目
    displayItems: []
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    update (state, data) {
      const rowData = utils.pick(data, utils.createKeys(query.GRAPH_QL_QUERY_PRODUCT_LIST, 1).edges.node)
      _.forEach(state.tdLists, (val, index) => {
        if (val.node.uuid === data.uuid) {
          _.merge(state.tdLists[index].node, _.cloneDeep(rowData))
        }
      })
    },
    delete (state, uuid) {
      _.remove(state.tdLists, (val) => val.uuid === uuid)
    }
  },
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/product.js